import 'bootstrap/dist/css/bootstrap.min.css';
import Container from 'react-bootstrap/Container';

function App() {
  return (
    <Container className="mt-5 text-center">
      <h1>SourceCaps Holding</h1>
      <p className="lead">Hello World - Site Under Construction</p>
    </Container>
  );
}

export default App;
